import CareerPlanOnboardingPage from "./_CareerPlanOnboardingPage";

export default function CareerPlanOnboardingRoute() {
  return <CareerPlanOnboardingPage />;
}
